import { atom } from 'recoil';

export const isNewServiceModalOpenAtom = atom<boolean>({
  key: 'isNewServiceModalOpenState',
  default: false,
});
